import React from "react";
import { Typography } from "antd";
import { PaperClipOutlined } from "@ant-design/icons";
import { ConnectedProps } from "react-redux";

import connector from "./Container";
import { getFileName } from "../../../../utils";

const ResponsePreview = ({
  actions,
  state,
}: ConnectedProps<typeof connector>) => {
  const { responseDetails, requestDetails } = state;

  const handleFileDownload = () => {
    if (actions.downloadFile && responseDetails.id) {
      actions.downloadFile(
        responseDetails.id,
        getFileName(responseDetails?.filePath)
      );
    }
  };

  return (
    <div className="flex justify-center items-center">
      <div className="px-8 py-4">
        <Typography className="text-xl font-bold text-center mb-6 text-secondary">
          ODGOVORILI STE NA ODABRANI ZAHTJEV:
          <span className="text-offer-blue ml-2">{requestDetails?.name}</span>
        </Typography>
        <div className="flex flex-col">
          <div className="flex justify-between my-2">
            <Typography className="text-right w-1/3 flex-shrink-0">
              Premija AK:
            </Typography>
            <Typography className="text-left w-2/3 ml-4">
              {responseDetails?.premiumAK}
            </Typography>
          </div>

          <div className="flex justify-between my-2">
            <Typography className="text-right w-1/3 flex-shrink-0">
              Premija AO:
            </Typography>
            <Typography className="text-left w-2/3 ml-4">
              {responseDetails?.premiumAO}
            </Typography>
          </div>

          <div className="flex justify-between my-2">
            <Typography className="text-right w-1/3 flex-shrink-0 ">
              Full troškovi registracije:
            </Typography>
            <Typography className="text-left w-2/3 ml-4">
              {responseDetails?.fullRegistrationCost}
            </Typography>
          </div>

          <div className="flex justify-between my-2">
            <Typography className="text-right w-1/3 flex-shrink-0">
              Osigurana suma:
            </Typography>
            <Typography className="text-left w-2/3 ml-4">
              {responseDetails?.insuredSum}
            </Typography>
          </div>

          <div className="flex justify-between my-2">
            <Typography className="text-right w-1/3 flex-shrink-0">
              Napomena:
            </Typography>
            <Typography className="text-left w-2/3 ml-4">
              {responseDetails?.note}
            </Typography>
          </div>

          <div className="flex justify-between my-2">
            <Typography className="text-right w-1/3 flex-shrink-0">
              Prilog:
            </Typography>
            <div className="flex items-center justify-start w-2/3 bg-light-gray ml-4">
              <PaperClipOutlined className="text-black opacity-45 ml-2" />
              <div
                className="ml-2 text-primary cursor-pointer"
                onClick={handleFileDownload}
              >
                {getFileName(responseDetails?.filePath)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResponsePreview;
